export const PAYMENT_PROVIDERS = ['stripe', 'square'];
export const MANUAL_PROVIDER = 'manual';
export const PAYMENT_TENDER_PROVIDERS = [...PAYMENT_PROVIDERS, MANUAL_PROVIDER];
export function isPaymentTenderProvider(value) {
    return PAYMENT_TENDER_PROVIDERS.includes(value);
}
export const MANUAL_TENDER_METHODS = ['cash', 'card_terminal', 'digital_transfer'];
export function isManualTenderMethod(value) {
    return MANUAL_TENDER_METHODS.includes(value);
}
export const PAYMENT_RECORD_STATUSES = ['pending', 'succeeded', 'failed', 'refunded', 'returned'];
export const INVOICE_STATUSES = ['due', 'sent', 'paid', 'voided', 'cancelled', 'processing'];
export const ACTIONABLE_INVOICE_STATUSES = ['due', 'sent'];
export const SETTLED_INVOICE_STATUSES = ['paid'];
export const TERMINAL_INVOICE_STATUSES = ['paid', 'voided', 'cancelled'];
export function isActionableInvoiceStatus(status) {
    return ACTIONABLE_INVOICE_STATUSES.includes(status);
}
export function isTerminalInvoiceStatus(status) {
    return TERMINAL_INVOICE_STATUSES.includes(status);
}
export const CARD_BRANDS = ['visa', 'mastercard', 'amex', 'discover', 'diners', 'jcb', 'unionpay', 'unknown'];
export function isPaymentProvider(value) {
    return PAYMENT_PROVIDERS.includes(value);
}
export function isPaymentRecordStatus(value) {
    return PAYMENT_RECORD_STATUSES.includes(value);
}
export function isInvoiceStatus(value) {
    return INVOICE_STATUSES.includes(value);
}
//# sourceMappingURL=constraints.js.map